// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --ml-text:#0f172a;
  --ml-muted:#475569;
  --ml-line:#e2e8f0;
  --ml-bg:#f8fafc;
  --ml-card:#ffffff;
}

.ml-wrap{
  min-height: 100vh;
  margin: 0;
  padding: 40px 16px;
  background: var(--ml-bg);
  color: var(--ml-text);
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  line-height: 1.55;
}

.ml-card{
  max-width: 920px;
  margin: 0 auto;
  background: var(--ml-card);
  border: 1px solid var(--ml-line);
  border-radius: 14px;
  padding: 26px;
  box-shadow: 0 10px 30px rgba(2,6,23,.06);
}

.ml-card h1{
  margin: 0 0 6px;
  font-size: 24px;
  letter-spacing: .2px;
}

.ml-sub{
  margin: 0 0 18px;
  color: var(--ml-muted);
  font-size: 14px;
}

.ml-card h2{
  margin: 18px 0 10px;
  font-size: 18px;
}

.ml-sec{
  margin: 10px 0 14px;
  padding-left: 14px;
  border-left: 3px solid var(--ml-line);
}

.ml-sec ul{
  margin: 8px 0 0 18px;
}

.ml-kv{
  display: grid;
  grid-template-columns: 190px 1fr;
  gap: 8px 14px;
  margin-top: 8px;
}

.ml-k{
  color: var(--ml-muted);
  font-weight: 600;
}

/* Responsive */
@media (max-width: 520px){
  .ml-card{
    padding: 18px;
  }
  .ml-kv{
    grid-template-columns: 1fr;
  }
  .ml-k{
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/footer/MentionsLegales.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":root{\n  --ml-text:#0f172a;\n  --ml-muted:#475569;\n  --ml-line:#e2e8f0;\n  --ml-bg:#f8fafc;\n  --ml-card:#ffffff;\n}\n\n.ml-wrap{\n  min-height: 100vh;\n  margin: 0;\n  padding: 40px 16px;\n  background: var(--ml-bg);\n  color: var(--ml-text);\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n  line-height: 1.55;\n}\n\n.ml-card{\n  max-width: 920px;\n  margin: 0 auto;\n  background: var(--ml-card);\n  border: 1px solid var(--ml-line);\n  border-radius: 14px;\n  padding: 26px;\n  box-shadow: 0 10px 30px rgba(2,6,23,.06);\n}\n\n.ml-card h1{\n  margin: 0 0 6px;\n  font-size: 24px;\n  letter-spacing: .2px;\n}\n\n.ml-sub{\n  margin: 0 0 18px;\n  color: var(--ml-muted);\n  font-size: 14px;\n}\n\n.ml-card h2{\n  margin: 18px 0 10px;\n  font-size: 18px;\n}\n\n.ml-sec{\n  margin: 10px 0 14px;\n  padding-left: 14px;\n  border-left: 3px solid var(--ml-line);\n}\n\n.ml-sec ul{\n  margin: 8px 0 0 18px;\n}\n\n.ml-kv{\n  display: grid;\n  grid-template-columns: 190px 1fr;\n  gap: 8px 14px;\n  margin-top: 8px;\n}\n\n.ml-k{\n  color: var(--ml-muted);\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 520px){\n  .ml-card{\n    padding: 18px;\n  }\n  .ml-kv{\n    grid-template-columns: 1fr;\n  }\n  .ml-k{\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
